module.exports = __webpack_public_path__ + "static/img/overview.a4f07de2.svg";